import { Brain, Calendar, CheckSquare, MessageSquare, User } from 'lucide-react'
import { NavLink } from 'react-router-dom'

const TABS = [
  { to: '/',          icon: Calendar,      label: 'Календарь' },
  { to: '/memory',    icon: Brain,         label: 'Память' },
  { to: '/tasks',     icon: CheckSquare,   label: 'Задачи' },
  { to: '/history',   icon: MessageSquare, label: 'История' },
  { to: '/profile',   icon: User,          label: 'Профиль' },
]

const SPRING = 'cubic-bezier(0.34, 1.56, 0.64, 1)'

export function TabBar() {
  return (
    <nav
      className="tab-bar fixed bottom-0 left-0 right-0 z-50 safe-bottom"
      style={{ height: 'calc(60px + env(safe-area-inset-bottom))' }}
    >
      <div className="flex h-[60px]">
        {TABS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-0.5 btn-active ${
                isActive ? 'text-accent' : 'text-ink-2'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className="flex items-center justify-center rounded-full"
                  style={{
                    width: 40,
                    height: 24,
                    background: isActive ? 'var(--color-accent-dim)' : 'transparent',
                    transform: isActive ? 'scale(1.06)' : 'scale(1)',
                    transition: `background 130ms ${SPRING}, transform 130ms ${SPRING}`,
                  }}
                >
                  <Icon
                    size={isActive ? 19 : 18}
                    strokeWidth={isActive ? 2 : 1.5}
                    style={{ transition: `all 130ms ${SPRING}` }}
                  />
                </div>
                <span
                  className="font-medium leading-none"
                  style={{ fontSize: '10px' }}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
